import SelectOrCreateDatasetDialog from "@/components/SelectOrCreateDatasetDialog";
import { useAuth } from "@/context/auth-context";
import { ToastType } from "@/enums";
import { useAddRequestLogToDataset } from "@/queries";
import { displayToast } from "@/utils/toast";

interface AddRequestLogToDatasetDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  requestLogId: number | null;
}

const AddRequestLogToDatasetDialog = ({
  isOpen,
  onOpenChange,
  requestLogId,
}: AddRequestLogToDatasetDialogProps) => {
  const userToken = useAuth()?.userToken ?? "";
  const addRequestLogToDataset = useAddRequestLogToDataset(userToken);

  const handleConfirm = async (datasetGroupId: number): Promise<boolean> => {
    if (!requestLogId) {
      displayToast("Could not add request to dataset", ToastType.error);
      return false;
    }

    try {
      const response = await addRequestLogToDataset.mutateAsync({
        dataset_group_id: datasetGroupId,
        request_log_id: requestLogId,
      });

      if (response?.success === false) {
        displayToast(response?.message ?? "Could not add request to dataset", ToastType.error);
        return false;
      }

      displayToast("Request added to dataset", ToastType.success);
      return true;
    } catch {
      displayToast("Could not add request to dataset", ToastType.error);
      return false;
    }
  };

  return (
    <SelectOrCreateDatasetDialog
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      onConfirm={handleConfirm}
      userToken={userToken}
      title="Add Request to Dataset"
      description="Pick an existing dataset or create a new one for this request."
      submitLabel="Add request"
      submitNewLabel="Create & add request"
    />
  );
};

export default AddRequestLogToDatasetDialog;
